import { Flex } from '@chakra-ui/react';
import { DiffModal } from '../common/DiffModal';
import { IFiguresAndTablesFile } from '@publishing-engine/domain/models/submission';
import { FormFieldGraphicalAbstractImage } from '@publishing-engine/domain/types/article';
import { GraphicalAbstractImageEmptyState } from './GraphicalAbstractImageEmptyState';
import GraphicalAbstractImageDisplay from './GraphicalAbstractImageDisplay';

interface Props {
  value?: IFiguresAndTablesFile;
  previousValue?: IFiguresAndTablesFile;
  onClose: () => void;
  config: Omit<FormFieldGraphicalAbstractImage, 'component'>;
}

export const GraphicalAbstractImageDiffModal = ({
  value,
  previousValue,
  onClose,
  config
}: Props) => {
  const label = config.params.labels.main;
  const hasPrevious = !!previousValue?.length;
  const hasCurrent = !!value?.length;

  return (
    <DiffModal onClose={onClose}>
      <DiffModal.LeftSide label={label}>
        <Flex flexDirection="column" gap={2}>
          {!hasPrevious ? (
            <GraphicalAbstractImageEmptyState
              fieldLabels={config.params.labels}
            />
          ) : (
            <GraphicalAbstractImageDisplay images={previousValue} />
          )}
        </Flex>
      </DiffModal.LeftSide>

      <DiffModal.RightSide label={label}>
        <Flex flexDirection="column" gap={2}>
          {!hasCurrent ? (
            <GraphicalAbstractImageEmptyState
              fieldLabels={config.params.labels}
            />
          ) : (
            <GraphicalAbstractImageDisplay images={value} />
          )}
        </Flex>
      </DiffModal.RightSide>
    </DiffModal>
  );
};
